import React from 'react';

/**
 * 1280px max-width 중앙 정렬 컨테이너
 * @param {object} props
 * @param {React.ReactNode} props.children
 * @param {string} [props.className]
 * @param {React.ElementType} [props.as='div']
 */
const Container = ({ children, className = '', as: Tag = 'div', ...rest }) => {
  const base = {
    maxWidth: 'var(--container-max)',
    margin: '0 auto',
    padding: '0 var(--container-padding)',
    width: '100%',
  };
  return (
    <Tag style={base} className={className} {...rest}>
      {children}
    </Tag>
  );
};

export default Container;
